import { useNavigate } from 'react-router-dom';
import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useCreateProductConcern = ({ reset }) => {
  const navigate = useNavigate();
  
  const { setDataToServer } = useCreate({
    url: 'concern/create',
    refreshUrl: 'concern/list',
    onSuccess: () => {
      reset?.();
      toast.success("Concern Added Successfully", {
        position: "top-right",
        duration: 3000
      });
      navigate('/catalog/concerns');
    }
  });
  
  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useCreateProductConcern;
